/* @flow weak */

// NOTE: "balfour" build target is for Magento 2+ balfour.com integration

'use strict';

const _ = require('lodash');

const DefaultConfig = {
  loaderStrategy: 'magento',
  schoolCodeRequired: true,
  skuPricing: true,
  previewSectionWidthMultiplier: 0.4, // % of main UC div
  features: {
    selectionSummary: false,
    questionNextButton: true,
    socialShareButtonOnly: true,
    newErrorStyling: true
  },
  images: {
    imageRendererCat: 'bal4render',
    s3url: __IMAGE_STORAGE_URL__
  },
  checkLogin: 'balapp.iframeprod.checkLogin',
  analytics: {
    enableTracking: true,
    eventTrackingTarget: 'pushToGTM',
    eventCategory: 'Class Rings Personalization'
  },
  images: {
    s3url: 'https://balfourdevuc.blob.core.windows.net/publicblobs/'
  },
  socialSharing: {
    facebook: 'fbDialog',
    pinterest: 'pinDialog',
    twitter: 'twitterDialog',
    email: 'emailDialog',
    wishlist: 'saveToWishlist',
    share: 'ucShareFeature'
  },
  breakpoints: {
    small: 676,
    medium: 768,
    large: 1440,
    extraLarge: 1920,
    fixedHeaderHeightTarget: '.fixed'
  },
  fixedHeaderHeightMedium: 84,
  fixedHeaderHeightLarge: 112,
};

// UC 1 local
// if (__LOCAL__) {
//   var Config = {
//     rootUrl: 'https://uc-qa.balfour.com/api',
//     api: {
//       loadProduct: 'https://uc-qa.balfour.com/api/product/',
//       loadConfig: 'https://uc-qa.balfour.com/api/load-configuration/',
//       saveConfig: 'https://uc-qa.balfour.com/api/save',
//       savePartialConfig: 'https://uc-qa.balfour.com/api/save-partial',
//       loadSchoolData: 'https://uc-qa.balfour.com/api/schoolfinder/',
//       highSchoolOrderForm: 'https://uc-qa.balfour.com/api/pdf/hsrings'
//     }
//   };
// }
let siteUrl;


// UC 2 local to STAGE
// if (__LOCAL__) {
//   var Config = {
//     api: {
//       loadProduct: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/product/',
//       loadConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/load-configuration/',
//       saveConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/save',
//       savePartialConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/save-partial',
//       loadSchoolData: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/schoolfinder/',
//       highSchoolOrderForm: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/pdf/hsrings'
//     }
//   };
// }

// UC 2 local to PROD
if (__LOCAL__) {
  var Config = {
    rootUrl: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/',
    api: {
      loadProduct: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/product/',
      loadConfig: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/load-configuration/',
      saveConfig: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/save',
      savePartialConfig: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/save-partial',
      loadSchoolData: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/schoolfinder/',
      highSchoolOrderForm: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/pdf/hsrings'
    }
  };
  // var Config = {
  //   api: {
  //     loadProduct: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/product/',
  //     loadConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/load-configuration/',
  //     saveConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/save',
  //     savePartialConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/save-partial',
  //     loadSchoolData: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/schoolfinder/',
  //     highSchoolOrderForm: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/pdf/hsrings'
  //   }
  // };
}

if (__DEV__ || __QA__ || __STAGING__) {
  siteUrl = __STAGE_SITE_URL__;
  var Config = {
    api: {
      loadProduct: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/product/',
      loadConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/load-configuration/',
      saveConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/save',
      savePartialConfig: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/save-partial',
      loadSchoolData: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/schoolfinder/',
      highSchoolOrderForm: 'https://dev-api-ops-balfour.azure-api.net/stage/fragment/api/v1/balfour/pdf/hsrings'
    }
  };
}

// UC 1  PROD
// if (__PROD__) {
//   var Config = {
//     rootUrl: 'https://uc-temp.balfour.com/',
//     api: {
//       loadProduct: 'https://uc-temp.balfour.com/api/product/',
//       loadConfig: 'https://uc-temp.balfour.com/api/load-configuration/',
//       saveConfig: 'https://uc-temp.balfour.com/api/save',
//       savePartialConfig: 'https://uc-temp.balfour.com/api/save-partial',
//       loadSchoolData: 'https://uc-temp.balfour.com/api/schoolfinder/',
//       highSchoolOrderForm: 'https://uc-temp.balfour.com/pdf/hsrings'
//     }
//   };
// }

// UC 2 PROD
if (__PROD__) {
  var Config = {
    rootUrl: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/',
    api: {
      loadProduct: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/product/',
      loadConfig: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/load-configuration/',
      saveConfig: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/save',
      savePartialConfig: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/save-partial',
      loadSchoolData: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/schoolfinder/',
      highSchoolOrderForm: 'https://api-ops.azure-api.net/prod/fragment/api/v1/balfour/pdf/hsrings'
    }
  };
}

module.exports = _.merge(DefaultConfig, Config);


// WEBPACK FOOTER //
// ./src/base/scripts/configs/Config.balfour.js